










































































import Vue from 'vue';
import i18n from 'vue-i18n';
import CoImage from '../../Atoms/co-image/CoImage.vue';
import CoText from '../../Atoms/co-text/CoText.vue';
import CoLink from '../../Atoms/co-link/CoLink.vue';

Vue.use(i18n);

export default {
    name: 'CoFooterPublic',
    components: {
        CoImage,
        CoText,
        CoLink,
    },
    i18n: {
        messages: {
            en: {
                createyourcommunity: 'Create your own community for free',
            },
            de: {
                createyourcommunity: 'Erstelle deine eigene Community kostenlos',
            },
        },
    },
    props: {
        cobranding: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        // Keep the public footer aligned with the global EventsOff feature flag.
        isEventsEnabled() {
            return !this.$store?.state?.space?.EventsOff;
        },
        // Legacy Off flags default to enabled; new On flags require an explicit opt-in.
        legalSettings() {
            return this.$store?.state?.space || {};
        },
    },
};
